import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { HFSMapState } from './models/map-state';

export const initialState: HFSMapState = {
  initialBounds: null,
  opacity: 1,
};

const mapSlice = createSlice({
  name: 'map',
  initialState,
  reducers: {
    setInitialBounds: (state, action: PayloadAction<google.maps.LatLngBounds>) => {
      state.initialBounds = action.payload;
    },
    setOpacity: (state, action: PayloadAction<number>) => {
      state.opacity = action.payload;
    },
  },
});

export const { setInitialBounds, setOpacity } = mapSlice.actions;

// Export reducer
export default mapSlice.reducer;
